<div class="step" *ngIf="stepProperties" [style.--color]="brandColor">
  <div class="step-number">{{ stepProperties.index }}</div>
  <div class="step-icon" [ngSwitch]="step">
    <div class="background-opacity"></div>
    <common-pack-icon class="icon" *ngSwitchCase="InstructionsSteps.PACK" [color]="brandColor"></common-pack-icon>
    <common-print-icon class="icon" *ngSwitchCase="InstructionsSteps.PRINT" [color]="brandColor"></common-print-icon>
    <common-greet-icon class="icon" *ngSwitchCase="InstructionsSteps.GREET" [color]="brandColor"></common-greet-icon>
  </div>
  <div class="step-descriptions">
    <div class="title">{{ stepProperties.title }}</div>
    <div class="description">
      <a *ngIf="step === InstructionsSteps.PRINT" [href]="labelUrl" class="label-link">Print this label</a>
      {{ stepProperties.description }}
    </div>
  </div>
</div>
<div *ngIf="!lastStep" class="step-separator" [style.--color]="brandColor"></div>
